import merge from 'lodash/merge'

import { IMessage, INonQliqMessage } from '@shared/models/proto/base/messages'

import { ChatStatus } from '@protos/chat/chat_status_pb'

export const updateMessagesDeliveredStatus = (
  // TODO: add protos when available
  // eslint-disable-next-line
  data: any,
  messages: IMessage[]
) =>
  messages.map((msg) => {
    if (msg.id !== data.message_id) {
      return msg
    }

    if (!msg.actualStatus) {
      msg.actualStatus = new ChatStatus()
    }
    msg.actualStatus.deliveredTime = data.delivered_time

    return msg
  })

export const updateMessagesReadStatus = (
  // TODO: add protos when available
  // eslint-disable-next-line
  data: any,
  messages: IMessage[]
) =>
  messages.map((msg) => {
    if (msg.id !== data.message_id) {
      return msg
    }

    if (!msg.actualStatus) {
      msg.actualStatus = new ChatStatus()
    }
    msg.actualStatus.readTime = data.read_time

    return msg
  })

export const updateMessagesRecallStatus = (
  // TODO: add protos when available
  // eslint-disable-next-line
  data: any,
  messages: IMessage[]
) =>
  messages.map((msg) => {
    if (msg.id !== data.message_id) {
      return msg
    }

    if (!msg.actualStatus) {
      msg.actualStatus = new ChatStatus()
    }
    msg.actualStatus.recalledFromAt = data.recalled_from_at
    return msg
  })

export const updateNonQlickMessagesReadStatus = (
  // TODO: add protos when available
  // eslint-disable-next-line
  data: any,
  messages: INonQliqMessage[]
) => {
  return messages.map((msg) =>
    msg.callId === data.call_id
      ? merge(msg, {
          deliveredTime: data.delivered_time,
          readTime: data.read_time,
        })
      : msg
  )
}
